<ng-container *transloco="let t; read: 'rating'">
  <div class="main-content" *ngIf="ac !== null && slot !== null">

    <app-content-header
      [title]="slot.exercisename + ': ' + slot.name + ' (' + t('rating') + ')'"
      [group]="group"
      [candidate]="candidate"
      [slot]="slot"
      [mode]="'rating'"
    >
    </app-content-header>

    <div class="layout-content" *ngIf="ratingtype !== null">
      <app-close-button></app-close-button>
      <div class="acr-card-body">

        <app-candidate-selector
          [candidate]="candidate"
          [exercise]="exercise"
          [group]="group"
          (candidateChange)="changeCandidate($event)"
        ></app-candidate-selector>

        <p-table [value]="competences" dataKey="id" styleClass="p-datatable-sm">

          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3rem"></th>
              <th>{{ t("competence_behavioranchor") }}</th>
              <th style="width: 25%;">{{ t("my_rating") }}</th>
              <ng-container *ngIf="isMod && foreignRatings !== null">
                <th class="p-text-center" *ngIf="isMod && !auth.isModerator()" style="width: 10%">{{ ac.moderator?.lastname}}</th>
                <ng-container *ngFor="let observer of ac.observers">
                  <ng-container *ngIf="observer.role !== 'moderator' && (ac.isSingle() || group === null || group.isInGroup(observer.hashed_id))">
                    <th class="p-text-center" style="width: 10%" [hidden]="auth.isMe(observer.hashed_id)">
                      <span [class.silent]="observer.type !== 'active'">{{ observer.lastname }}</span>
                    </th>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-competence let-expanded="expanded">
            <tr>
              <td>
                <button
                  type="button"
                  pButton
                  pRipple
                  [pRowToggler]="competence"
                  class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                ></button>
              </td>
              <td>{{ competence.getLang("name", language) }}</td>
              <td style="width: 25%;" class="p-text-right">
                <app-rating-slider
                  [(value)]="competence.value"
                  [min]="ratingtype.min_value"
                  [max]="ratingtype.max_value"
                  [step]="ratingtype.step"
                  (userChange)="saveRating()"
                  [disabled]="!isActive()"
                ></app-rating-slider>
              </td>
              <ng-container *ngIf="isMod && foreignRatings !== null">
                <td class="p-text-center foreign-value" *ngIf="isMod && !auth.isModerator()" style="width: 10%" [innerHtml]="getForeignValue(ac.moderator?.hashed_id, competence)"></td>
                <ng-container *ngFor="let observer of ac.observers">
                  <ng-container *ngIf="observer.role !== 'moderator' && (ac.isSingle() || group === null || group.isInGroup(observer.hashed_id))">
                    <td class="p-text-center foreign-value" style="width: 10%" [hidden]="auth.isMe(observer.hashed_id)">
                      <span *ngIf="observer.type === 'active'" [innerHtml]="getForeignValue(observer.hashed_id, competence)"></span>
                      <ng-container *ngIf="observer.type !== 'active'">
                        <fa-icon [icon]="faBan"></fa-icon>
                      </ng-container>
                    </td>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template pTemplate="rowexpansion" let-competence>
            <tr class="behavioranchors">
              <td [attr.colspan]="3 + (isMod ? ac.observers.length : 0)" style="padding: 0">
                <p-table [value]="competence.behavioranchors" dataKey="id" styleClass="p-datatable-sm">
                  <ng-template pTemplate="body" let-behavioranchor>
                    <tr class="behavioranchors">
                      <td style="width: 3rem"></td>
                      <td class="behavioranchor">{{ behavioranchor.content }}</td>
                      <td class="p-text-right" style="width: 25%">
                        <app-rating-slider
                          [(value)]="behavioranchor.value"
                          [min]="ratingtype.min_value"
                          [max]="ratingtype.max_value"
                          [step]="ratingtype.step"
                          [type]="SliderTypes.Behavioranchor"
                          (valueChange)="calcCompetence(competence)"
                          (userChange)="saveRating()"
                          [disabled]="!isActive()"
                        ></app-rating-slider>
                      </td>
                      <ng-container *ngIf="isMod && foreignRatings !== null">
                        <td class="p-text-center foreign-value" *ngIf="isMod && !auth.isModerator()" style="width: 10%"></td>
                        <ng-container *ngFor="let observer of ac.observers">
                          <ng-container *ngIf="observer.role !== 'moderator' && (ac.isSingle() || group === null || group.isInGroup(observer.hashed_id))">
                            <td class="p-text-center foreign-value" [hidden]="auth.isMe(observer.hashed_id)" style="width: 10%"></td>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </ng-template>
                </p-table>
              </td>
            </tr>
          </ng-template>

        </p-table>

        <ng-container *ngIf="isMod === true">
          <h2>{{ t('comments') }}</h2>
          <textarea
            [(ngModel)]="comments"
            (blur)="saveRating()"
            [disabled]="!isActive()"
            pInputTextarea
            rows="5"
            style="width: 100%;"
          ></textarea>
        </ng-container>

        <div *ngIf="this.ratingtype.getLang('legend', language)" class="legend">
          <h2>{{ t('legend') }}</h2>
          <p [innerHtml]="this.ratingtype.getLang('legend', language) | nl2br"></p>
        </div>

      </div>
    </div>
  </div>

</ng-container>
